'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _TypographyElement = require('./TypographyElement');

var _TypographyElement2 = _interopRequireDefault(_TypographyElement);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultProps = {
  component: 'p'
};

var Body2 = function Body2(props) {
  return _react2.default.createElement(_TypographyElement2.default, _extends({
    modificator: 'body2'
  }, props));
};

Body2.defaultProps = defaultProps;
exports.default = Body2;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-mdc-web/lib/Typography/Body1.js
// module id = 343
// module chunks = 0